<template>
  <v-container fluid class="mt-16 px-6">
    <div class="">
      <v-card flat v-if="ready">
        <v-card-title>
          <h2>Employees</h2>

          <div class="d-flex mt-4">
            <add-employee-modal />
            <cash-advances class="ml-2" />
            <positions class="ml-2" />
            <benefits class="ml-2" />
            <employee-benefits class="ml-2" />
            <PayslipModal class="ml-2" />
          </div>
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- table -->
          <div class="d-flex">
            <v-text-field
              v-model="search"
              label="Search"
              prepend-icon="mdi-magnify"
              class="mr-5"
            ></v-text-field>
            <v-select
              v-model="selectedBranchId"
              :items="branchOptions"
              item-text="branch_name"
              item-value="id"
              label="Branch"
              clearable
              style="max-width: 300px"
              @change="onBranchChange"
            ></v-select>
          </div>
          <v-data-table
            :items="filteredEmployees"
            :headers="employees_table"
            :search="search"
            dense
          >
            <template v-slot:item.is_active="{ item }">
              <span class="red--text" v-if="item.is_active == 0">Inactive</span>
              <span v-else class="green--text">Active</span>
            </template>
            <template v-slot:item.employment_status="{ item }">
              <v-chip
                small
                :color="
                  item.employment_status === 'regular' ? 'green' : 'orange'
                "
                text-color="white"
              >
                {{
                  item.employment_status === "regular"
                    ? "Regular"
                    : "Probationary"
                }}
              </v-chip>
            </template>
            <template v-slot:item.monthly_salary="{ item }">
              <span v-if="item.employment_status === 'regular'">{{
                item.monthly_salary
              }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.action="{ item }">
              <div class="d-flex">
                <edit-employee-modal :item="item" />

                <v-btn icon color="red" @click="del(item)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <div></div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import addEmployeeModal from "@/components/Employee/addEmployeeModal.vue";
// import AddEmployeeWageModal from "../components/Employee/addEmployeeWageModal.vue";
import EditEmployeeModal from "../components/Employee/editEmployeeModal.vue";
import Positions from "../components/Employee/positions.vue";
import Benefits from "../components/Employee/benefits.vue";
import employeeBenefits from "../components/Employee/employeeBenefits.vue";
// import WagesModal from "../components/Employee/payslipModal.vue";
import CashAdvances from "../components/Employee/cashAdvances.vue";
import PayslipModal from "../components/Employee/payslipModal.vue";
export default {
  components: {
    addEmployeeModal,

    EditEmployeeModal,
    Positions,
    Benefits,
    employeeBenefits,
    PayslipModal,
    CashAdvances,
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
      employees: "employee/employees",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
      wages: "wage/wages",
      branches: "branch/branches",
    }),
    branchOptions() {
      return this.branches || [];
    },
    filteredEmployees() {
      if (!this.selectedBranchId) return this.employees;
      return this.employees.filter(
        (e) => e.branch_id === this.selectedBranchId
      );
    },
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    ...mapActions({
      get_employees: "employee/get_employees",
      delete_employee: "employee/delete_employee",
    }),
    onBranchChange() {
      this.get_employees(this.selectedBranchId);
    },
    async del(item) {
      let x = await this.$confirm({
        title: "Delete Employee",
        message: "Are you sure you want to delete this employee?",
        color: "red",
        icon: "mdi-delete",
      });
      if (x)
        this.delete_employee(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully deleted an employee",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
    },
    open_modal() {
      // gated by the employees.open_modal permission (hat bundle)
      if (!this.can("employees.open_modal"))
        this.$alert({
          title: "Error",
          message: "You are not allowed to access this page",
          color: "error",
          icon: "mdi-alert-circle",
        });
      else this.dialog = true;
    },
    print(item) {
      var url =
        this.default_server_url +
        "/" +
        "print_pay_slip" +
        "/" +
        item.employee_id +
        "/" +
        item.half +
        "/" +
        item.month +
        "/" +
        item.year;
      window.open(url);
    },
  },
  created() {
    if (this.employees.length == 0 || this.wages.length == 0) {
      this.get_employees().then(() => {
        this.ready = true;
      });
    }
    if (!this.branches || this.branches.length === 0) {
      this.$store.dispatch("branch/get_branches");
    }
    this.selectedBranchId = this.user.branch_id;
    this.ready = true;
  },
  data() {
    return {
      search: "",
      ready: false,
      selectedBranchId: null,

      employees_table: [
        { text: "", value: "action" },
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Contact Number", value: "contact_no" },
        { text: "Address", value: "address" },
        { text: "Employment Date", value: "date_of_employment" },
        { text: "Position", value: "position.name" },
        { text: "Status", value: "employment_status" },
        { text: "Monthly Salary", value: "monthly_salary" },
        { text: "Daily Rate", value: "position.base_rate_per_day" },
        { text: "Total Wage Received", value: "total_wage_received" },
        { text: " Overtime Rate", value: "overtime_rate" },
        { text: "Active Status", value: "is_active" },
      ],
      table_loading: true,
      dialog: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
